import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * useScrollAnimation
 * Runs a GSAP animation callback scoped to a ref, and cleans up
 * every ScrollTrigger + tween created inside it on unmount.
 *
 * @param {(ctx: { el: HTMLElement, gsap: typeof gsap, ScrollTrigger: typeof ScrollTrigger }) => void} callback
 * @param {any[]} deps
 */
export default function useScrollAnimation(callback, deps = []) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return undefined;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    let ctx;
    if (!reduceMotion) {
      ctx = gsap.context(() => {
        callback({ el: ref.current, gsap, ScrollTrigger });
      }, ref);
    }

    return () => {
      if (ctx) ctx.revert();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}
